import { ExclamationTriangleIcon } from '@heroicons/react/24/outline';
import Modal from 'react-modal';

import { PrimaryButton, SecondaryButton } from 'components/Button';

if (typeof window !== 'undefined') {
  Modal.setAppElement('#root');
}

interface IncompleteGuestListModalProps {
  isOpen: boolean;
  onClose: () => void;
  onConfirm: () => void;
  filledCount: number;
  totalCount: number;
  isProcessing?: boolean;
}

const IncompleteGuestListModal: React.FC<IncompleteGuestListModalProps> = ({
  isOpen,
  onClose,
  onConfirm,
  filledCount,
  totalCount,
  isProcessing = false,
}) => {
  return (
    <Modal
      isOpen={isOpen}
      onRequestClose={onClose}
      className="relative mx-auto mt-20 max-w-md rounded-lg bg-white p-6 shadow-xl"
      overlayClassName="fixed inset-0 z-50 flex items-start justify-center bg-black bg-opacity-50 px-4 overflow-y-auto"
      closeTimeoutMS={200}
    >
      <div className="mb-4 flex items-start">
        <ExclamationTriangleIcon className="mr-3 size-6 shrink-0 text-yellow-600" />
        <div>
          <h2 className="text-lg font-semibold text-gray-900">
            Incomplete Guest List
          </h2>
          <p className="mt-1 text-sm text-gray-600">
            You have assigned {filledCount} of {totalCount} guests.
          </p>
        </div>
      </div>

      <div className="mb-6 rounded-md border border-gray-200 bg-gray-50 p-4">
        <p className="text-sm text-gray-700">
          The remaining guests can be added later from the trips page after
          booking is complete.
        </p>
      </div>

      <div className="flex gap-3">
        <SecondaryButton
          text="Cancel"
          onClick={onClose}
          type="button"
          className="flex-1"
          disabled={isProcessing}
        />
        <PrimaryButton
          text={isProcessing ? 'Submitting...' : 'Submit Anyway'}
          onClick={onConfirm}
          disabled={isProcessing}
          className="flex-1"
        />
      </div>
    </Modal>
  );
};

export default IncompleteGuestListModal;
